import { render, staticRenderFns } from "./consumeDetail.vue?vue&type=template&id=52b8f57c&scoped=true&"
import script from "./consumeDetail.vue?vue&type=script&lang=js&"
export * from "./consumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./consumeDetail.vue?vue&type=style&index=0&id=52b8f57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8f57c",
  null
  
)

export default component.exports